import React from 'react';
import { FiChevronLeft, FiArrowLeft } from 'react-icons/fi';

export default function AddEquipmentHeader() {
  return (
    <div className="w-full bg-white px-6 py-4 flex flex-col md:flex-row md:items-center md:justify-between border-b border-gray-100">
      {/* Left Section: Breadcrumbs and Title Info */}
      <div className="flex flex-col space-y-2">
        {/* Breadcrumb Links */}
        <div className="flex items-center text-sm font-medium text-blue-600 space-x-1">
          <FiChevronLeft className="w-4 h-4 text-blue-600" />
          <a href="#equipment" className="hover:underline">Equipment</a>
          <span className="text-gray-400 font-normal mx-1">&gt;</span>
          <span className="text-gray-500 font-normal">Add New Equipment</span>
        </div>

        {/* Main Heading and Subtext */}
        <div>
          <h1 className="text-2xl font-bold text-slate-900 tracking-tight">
            Add New Equipment
          </h1>
          <p className="text-sm text-slate-500 mt-0.5">
            Register a new piece of equipment to track its usage, maintenance, safety and compliance.
          </p>
        </div>
      </div>

      {/* Right Section: Action Button */}
      <div className="mt-4 md:mt-0 flex items-start">
        <button 
          onClick={() => window.history.back()}
          className="inline-flex items-center justify-center px-4 py-2 text-sm font-semibold text-slate-700 bg-white border border-slate-200 rounded-lg shadow-sm hover:bg-slate-50 transition-colors focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
        >
          <FiArrowLeft className="w-4 h-4 mr-2 text-slate-600" />
          Back to All Equipment
        </button>
      </div>
    </div>
  );
}
